import { FC, Fragment } from "react";
import React from "react";
import { FormControl, RadioGroup } from "@material-ui/core";
import { ChangeNames } from "../../clients/FirebaseClient/types";
import { useFormModel } from "../core/FormModelHelpes";
import { useStyles } from "../../useStyles";
import { FormControlLabel } from "../core/FormControlLabel";
import { Radio } from "../core/Radio";

export const ChargerPrivateParkingUsagesForm: FC = () => {
    const classes = useStyles();
    const { values, setValues } = useFormModel<ChangeNames.CHARGER_PRIVATE_PARKING_USAGES>();

    const value = values.chargerPrivateParkingUsages.value;
    const selection = Object.keys(value)
        .filter(key => value[key as keyof typeof value])
        .sort()
        .join("#");

    return (
        <Fragment>
            <div className={classes.container}>
                <h4 className={classes.h4} style={{ marginBottom: 0, marginTop: 40 }}>
                    Nutzung der Ladeeinrichtung
                </h4>
                <FormControl component="fieldset" style={{ display: "flex" }}>
                    <RadioGroup
                        value={selection}
                        onChange={(e, v) => {
                            setValues(values => {
                                values.chargerPrivateParkingUsages.value = {
                                    private: v.indexOf("private") >= 0,
                                    employee: v.indexOf("employee") >= 0,
                                };
                            });
                        }}
                    >
                        <FormControlLabel
                            value="private"
                            control={<Radio />}
                            label="Laden auf dem Privatparkplatz"
                            text="Die Ladeeinrichtung wird nur von Ihnen, Ihrer Familie oder Freunden genutzt."
                            error={values.chargerPrivateParkingUsages.error !== null}
                        />
                        <FormControlLabel
                            value="employee"
                            control={<Radio />}
                            label="Laden auf dem Mitarbeiterparkplatz"
                            text="Die Ladeeinrichtung steht ausschließlich den Mitarbeitern zur Verfügung. Kunden dürfen diese nicht nutzen."
                            error={values.chargerPrivateParkingUsages.error !== null}
                        />
                    </RadioGroup>
                </FormControl>
            </div>
        </Fragment>
    );
};
